module.exports = "/public/webpack/img/icon_help_categories_search_32e531c3c5c77d1fd17c58124a7d6cc51e.png";